import React, { useState } from 'react';
import { Navbar, Nav, Button, Dropdown } from 'react-bootstrap';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './nav.css';
import logo from '../../Images/optimized/our-place-logo-header.webp';
import { useAuth } from '../../hooks/useAuth';

/* Every link here used to be a bare href, so clicking "Our Experts" tore the
   whole app down and rebuilt it: re-download the bundle, re-run the token
   check, white flash. As router links they are a state change — and NavLink
   also marks the current page for assistive tech, which anchors never did. */
const Navigation = () => {
  const { user, logout, loading } = useAuth();
  // Client-side navigation no longer reloads the page, so the mobile menu has
  // to be told to close itself after a link is followed.
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const closeMenu = () => setExpanded(false);

  const handleLogout = async () => {
    closeMenu();
    const result = await logout();
    if (result.success) {
      navigate('/');
    }
  };

  return (
    <>
      <Navbar
        expand="lg"
        bg="white"
        variant="light"
        fixed="top"
        expanded={expanded}
        onToggle={setExpanded}
      >
        <div className="container">
          <Navbar.Brand as={Link} to="/" onClick={closeMenu}>
            <img
              src={logo}
              alt="Join Our Place — home"
              className="logo"
              width="80"
              height="58"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarNav" aria-label="Toggle navigation" />
          <Navbar.Collapse id="navbarNav">
            <Nav className="ms-auto align-items-center">
              <Nav.Link as={NavLink} to="/ourplaces" onClick={closeMenu}>OUR PLACES</Nav.Link>
              <Nav.Link as={NavLink} to="/knowledgecenter" onClick={closeMenu}>KNOWLEDGE CENTER</Nav.Link>
              <Nav.Link as={NavLink} to="/experts" onClick={closeMenu}>OUR EXPERTS</Nav.Link>

              {/* Authentication Button/Dropdown */}
              <div className="nav-auth-slot ms-2">
              {user ? (
                <Dropdown className="user-dropdown">
                  <Dropdown.Toggle variant="outline-primary" id="user-dropdown" className="user-dropdown-toggle">
                    {user.profilePicture ? (
                      <img
                        src={user.profilePicture}
                        alt=""
                        className="user-avatar-small"
                        width="32"
                        height="32"
                      />
                    ) : (
                      <span className="user-avatar-placeholder" aria-hidden="true">
                        {user.firstName?.[0]}{user.lastName?.[0]}
                      </span>
                    )}
                    <span className="ms-2">Signed in as <strong>{user.username}</strong></span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    <Dropdown.Item as={Link} to="/profile" onClick={closeMenu}>
                      👤 My Profile
                    </Dropdown.Item>
                    {user.role === 'admin' && (
                      <Dropdown.Item as={Link} to="/admin" onClick={closeMenu}>
                        ⚙️ Admin Dashboard
                      </Dropdown.Item>
                    )}
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>
                      🚪 Sign Out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : loading ? (
                /* Same footprint as the button it becomes, so the bar doesn't
                   twitch when the token check finishes. */
                <div style={{ width: 150, height: 36 }} aria-hidden="true" />
              ) : (
                /* The dedicated /signup page, not the modal: a real URL is
                   what Meta PageView and the campaigns key off. It opens on
                   sign-in (most nav clicks are returning members) and toggles
                   to create-account. */
                <Button
                  variant="outline-primary"
                  className="btn-login"
                  as={Link}
                  to="/signup"
                  onClick={closeMenu}
                >
                  Sign In / Sign Up
                </Button>
              )}
              </div>

              <Button variant="primary" className="btn-donate ms-2" as={Link} to="/donate" onClick={closeMenu}>
                Donate
              </Button>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>

    </>
  );
};

export default Navigation;
